// PrivacyPage.jsx
import React from 'react';
import './PrivacyPage.css';
import backgroundImg from '../assets/background.png';

const privacyText = `POLÍTICA DE PRIVACIDADE DO APLICATIVO FUT+

Última atualização: 17 de março de 2026

A sua privacidade é importante para nós. Esta Política de Privacidade descreve como a plataforma FUT+, de titularidade de Alisson Sorgatto Moreira Frank (CPF: 063.369.101-13) ("FUT+", "nós", "nosso" ou "Plataforma"), coleta, utiliza, compartilha e protege os seus dados pessoais ao utilizar nosso aplicativo e serviços.

Ao acessar ou se cadastrar no FUT+, você concorda com o tratamento de dados conforme descrito nesta Política. Caso não concorde, recomendamos que não utilize a Plataforma.


1. QUAIS DADOS COLETAMOS

1.1 Dados de cadastro e identificação

* Nome completo
* CPF
* Data de nascimento
* E-mail
* Número de telefone (incluindo WhatsApp)
* Foto de perfil

1.2 Dados esportivos (gerados na plataforma)

* Times em que o usuário participa
* Estatísticas (gols, assistências, cartões, partidas)
* Posição em campo e número da camisa
* Fotos e vídeos enviados na plataforma

1.3 Dados financeiros e de pagamento

Os pagamentos realizados no FUT+ são processados por parceiros terceiros (ex: Asaas).

Importante:
O FUT+ não armazena dados de cartão de crédito. Armazenamos apenas:

* Status do pagamento
* Identificador da transação

1.4 Dados de navegação

* Endereço IP
* Tipo de dispositivo
* Navegador e sistema operacional
* Dados de uso da aplicação


2. COMO UTILIZAMOS SEUS DADOS

Seus dados são utilizados para:

* Permitir o funcionamento da plataforma
* Criar e gerenciar campeonatos, times e jogadores
* Garantir identificação única de atletas
* Exibir estatísticas públicas (gols, cartões, rankings)
* Enviar comunicações importantes (status, avisos, atualizações)
* Prevenir fraudes e garantir segurança


3. COMPARTILHAMENTO DE DADOS

O FUT+ não vende dados pessoais.

Seus dados podem ser compartilhados nas seguintes situações:

3.1 Dentro da plataforma

* Nome (ou apelido), foto e estatísticas podem ser exibidos publicamente
* Informações esportivas ficam visíveis em campeonatos e rankings

3.2 Organizadores de campeonatos

* Nome, CPF, data de nascimento e foto podem ser acessados para validação de atletas

3.3 Prestadores de serviço

* Cloudinary (armazenamento de imagens e mídias)
* Asaas (processamento de pagamentos)

3.4 Obrigação legal

Quando exigido por lei ou autoridades competentes

3.5 Processamento por Inteligência Artificial
Para a geração de conteúdos informativos e narrações de partidas, o FUT+ utiliza serviços de Inteligência Artificial de terceiros. Os dados compartilhados para este fim limitam-se a nomes de atletas, nomes de equipes e estatísticas esportivas (gols, cartões e resultados). Dados sensíveis como CPF, endereços e informações de contato jamais são compartilhados com esses serviços.


4. ARMAZENAMENTO E SEGURANÇA

4.1 Armazenamento

Os dados são armazenados em serviços de nuvem seguros (como MongoDB Atlas, Render, entre outros).

4.2 Proteção

Adotamos medidas como:

* Criptografia de senhas
* Comunicação segura (HTTPS)
* Controle de acesso

4.3 Retenção de dados

Os dados são mantidos enquanto a conta estiver ativa.

Em caso de exclusão da conta:

* Dados pessoais serão removidos ou anonimizados
* Dados esportivos históricos poderão ser mantidos, sem identificação direta (para preservar a integridade das competições)


5. DIREITOS DO USUÁRIO (LGPD)

Você tem direito a:

* Confirmar a existência de tratamento de dados
* Acessar seus dados
* Corrigir dados incompletos ou desatualizados
* Solicitar exclusão de dados
* Revogar consentimento

Solicitações podem ser feitas via:
E-mail: suporte@futplus.com


6. COOKIES

Utilizamos cookies para:

* Manter o usuário autenticado
* Melhorar a experiência de uso

A desativação de cookies pode afetar o funcionamento da plataforma.


7. LINKS DE TERCEIROS

O FUT+ pode conter links externos. Não nos responsabilizamos pelas políticas de privacidade de terceiros.


8. ALTERAÇÕES NESTA POLÍTICA

Esta Política pode ser atualizada a qualquer momento. Recomendamos revisão periódica.

O uso contínuo da plataforma implica concordância com as alterações.


9. CONTATO

Para dúvidas relacionadas à privacidade:

Responsável: Alisson Sorgatto Moreira Frank
E-mail: suporte@futplus.com


Ao utilizar o FUT+, você declara estar ciente e de acordo com esta Política de Privacidade.
`;

const PrivacyPage = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <div className="privacy-header">
          <h1>Política de Privacidade</h1>
        </div>
        <div className="privacy-content">
          <pre className="privacy-text">{privacyText}</pre>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;